import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Dashboard from "@/pages/Dashboard";
import TestSetup from "@/pages/TestSetup";
import TestInterface from "@/pages/TestInterface";
import Results from "@/pages/Results";
import TestHistory from "@/pages/TestHistory";
import OmrMode from "@/pages/OmrMode";
import Feedback from "@/pages/Feedback";
import PreviousYears from "@/pages/PreviousYears";
import TopicTree from "@/pages/TopicTree";
import QuestionSeeder from "@/pages/QuestionSeeder";
import AdminTools from "@/pages/AdminTools";
import Sidebar from "@/components/Sidebar";
import Chatbot from "@/components/Chatbot";
import { Toaster } from "@/components/ui/sonner";

function AppContent() {
  const location = useLocation();
  const isExamMode = location.pathname.match(/^\/test\/[^/]+$/) && !location.pathname.includes("/results");

  return (
    <div className={`app-layout noise-bg ${isExamMode ? "exam-mode" : ""}`}>
      {!isExamMode && <Sidebar />}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/test/setup" element={<TestSetup />} />
          <Route path="/test/:testId" element={<TestInterface />} />
          <Route path="/test/:testId/results" element={<Results />} />
          <Route path="/history" element={<TestHistory />} />
          <Route path="/omr" element={<OmrMode />} />
          <Route path="/pyq" element={<PreviousYears />} />
          <Route path="/topics" element={<TopicTree />} />
          <Route path="/seeder" element={<QuestionSeeder />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/admin" element={<AdminTools />} />
        </Routes>
      </main>
      {!isExamMode && <Chatbot />}
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
